<template>
    <div>
        <div
            class="cabinet-product-detail-nav cabinet-product-detail-nav--product-detail flex flex-align-center mt-4 pt-4 pt-md-3"
        >
            <a
                href="javascript:void(0)"
                class="cabinet-product-detail-nav__link"
                :class="{ active: active === 'tspecifications' }"
                @click="setActive('tspecifications')"
                >Характеристики</a
            >
            <a
                href="javascript:void(0)"
                class="cabinet-product-detail-nav__link"
                :class="{ active: active === 'tinserts' }"
                @click="setActive('tinserts')"
                >Вставки</a
            >
            <a
                href="javascript:void(0)"
                class="cabinet-product-detail-nav__link"
                :class="{ active: active === 'tdescr' }"
                @click="setActive('tdescr')"
                >Описание</a
            >
        </div>

        <specifications v-if="active === 'tspecifications'" />

        <inserts v-if="active === 'tinserts'" />

        <descr v-if="active === 'tdescr'" />
    </div>
</template>

<script>
import Specifications from '@/components/Cabinet/Supplier/Product/Detail/DetailSpecifications.vue'
import Inserts from '@/components/Cabinet/Supplier/Product/Detail/DetailInserts.vue'
import Descr from '@/components/Cabinet/Supplier/Product/Detail/DetailDescr.vue'

export default {
    name: 'DetailTabs',
    components: { Specifications, Inserts, Descr },
    data() {
        return {
            active: 'tspecifications'
        }
    },
    methods: {
        setActive(tab) {
            this.active = tab
        }
    }
}
</script>
